import { AnalyticsAdapter } from './analytics.adapter';
import { AnalyticsService } from './analytics.service';
import * as T from './analytics.types';
import { AnalyticsMixpanelAdapter } from './adapters';

const adapters = new Map<T.AnalyticsAdapters, AnalyticsAdapter>([
  ['mixpanel', new AnalyticsMixpanelAdapter()]
]);

export class AnalyticsFactory {
  static _createAdapter(provider: T.AnalyticsAdapters): AnalyticsAdapter {
    const adapter = adapters.get(provider);
    if (!adapter) throw new Error(`Unknown analytics provider: ${provider}`);
    return adapter;
  }

  static createService(provider: T.AnalyticsAdapters): AnalyticsService {
    const adapter = this._createAdapter(provider);
    return new AnalyticsService(adapter);
  }
}

export const analytics = AnalyticsFactory.createService('mixpanel');
